module.exports = __webpack_public_path__ + "static/media/icon_instrument_trumpet.c27ed0ef.svg";